/*
 * Updated: Dec 19, 2024 | Currency Code Display | Product Price Optimization
 * - Updated price formatting functions to respect currency_code_enabled setting
 * - Replaced manual currency concatenation with proper Shopify money formatting
 * - Ensures currency codes display consistently across product and collection pages
 * - Removed front-end discount calculations in favor of Sales & Discount app
 * - Now relies on compare_at_price > price for sale display (set by Sales & Discount app)
 * - Simplified pricing logic to use backend-calculated prices
 */

'use strict';

window.addEventListener('DOMContentLoaded', (event) => {

  /**
   * selected frame variant
   */
  const frameSelection = document.querySelector('.variant_frame_name');

  if (frameSelection !== null) {
    frameSelection.addEventListener('click', (e) => {
      const frame_result = document.querySelector('.frame_value');
      frame_result.textContent = `${e.target.value}`;

      if (e.target.value == undefined) {
        frame_result.textContent = ` `;
      }
    });
  }

  /**
   * Product specs
   */
  const productTitle = document.querySelectorAll('.product-description-title');

  if (productTitle !== null) {
    productTitle.forEach((btn) => {
      const productData = document.querySelectorAll('.product-description-content');

      btn.addEventListener('click', (e) => {
        productData.forEach((content) => {
          if (e.target.nextElementSibling !== content && content.classList.contains('active')) {
            content.classList.remove('active');
            productTitle.forEach((btn) => btn.classList.remove('active'));
          }
        });
        const container = btn.nextElementSibling;
        container.classList.toggle('active');
        btn.classList.toggle('active');
      });
    });
  }

  /**
   * Product select variant
   */
  const selectLabel = document.querySelector('#select-variant');
  const selectArrow = document.querySelector('.arrow-down'); // define selectArrow here

  if (selectLabel !== null) {
    const dropdown = function () {
      const optionVariants = document.querySelector('.variant_options');

      optionVariants.classList.toggle('toggle-variant');
      selectArrow.classList.toggle('toggle-variant');
      selectLabel.classList.toggle('toggle-variant');
    };

    selectLabel.addEventListener('click', dropdown);

    // Listen for clicks on the options
    const variantOptions = document.querySelector('.variant_options');
    if (variantOptions !== null) {
      variantOptions.addEventListener("click", function (event) {
        // If an option was clicked (check with the class .product_option)
        if (event.target.matches('.product_variant')) {
          // Close the dropdown
          variantOptions.classList.toggle("toggle-variant");
          selectArrow.classList.toggle('toggle-variant'); // now selectArrow is defined
          selectLabel.classList.toggle("toggle-variant");
        }
      });
    } else {
      console.error("Could not find element with class '.variant_options'");
    }
  }


  /**
   * selected size variant
   */
  const optionSize = document.querySelector('.variant_options');

  if (optionSize !== null) {
    optionSize.addEventListener('click', (e) => {
      const result = document.querySelector('.selected-value');
      result.textContent = `Selected - ${e.target.value}`;

      if (e.target.value == undefined) {
        result.textContent = `Select`;
      }
    });
  }

  /**
   * selected no frame variant
   */
  const noSize = document.querySelector('.no_frame');
  const haveSize = document.querySelectorAll('.have_frame');
  const have_frame = document.querySelectorAll('.size');
  const no_frame = document.querySelectorAll('.size_no_frame');
  
  if (noSize) {
    const switchSize = function () {
      have_frame.forEach((item) => {
        item.classList.add('hide');
      });
      no_frame.forEach((item) => {
        item.classList.remove('hide');
      });
    };
    noSize.addEventListener('click', switchSize);
  }
  
  if (have_frame) {
    const switchFrame = function () {
      have_frame.forEach((item) => {
        item.classList.remove('hide');
      });
      no_frame.forEach((item) => {
        item.classList.add('hide');
      });
    };
  
    haveSize.forEach((item) => {
      item.addEventListener('click', switchFrame);
    });
  }
  

  function initObserver() {
    let targetNode = document.querySelector(".template-product #select-variant");
    let selectArrow = document.querySelector('.arrow-down'); // define selectArrow here

    if (targetNode) {
      let config = { childList: true, subtree: true };

      let callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            // Try to find the element again
            const selectLabel = document.querySelector("#select-variant");
            const variantOptions = document.querySelector(".variant_options");

            if (selectLabel && variantOptions) {
              selectLabel.addEventListener("click", function () {
                variantOptions.classList.toggle("toggle-variant");
                selectArrow.classList.toggle('toggle-variant');
              });

              variantOptions.addEventListener("click", function (event) {
                if (event.target.matches('.product_option')) {
                  variantOptions.classList.toggle("toggle-variant");
                  selectArrow.classList.toggle('toggle-variant');
                  selectLabel.classList.toggle("toggle-variant");
                }
              });

              // Once found and event listeners added, there's no need to observe anymore.
              observer.disconnect();
            }
          }
        }
      };

      let observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }
  }


  // Start observing as soon as the page is fully loaded
  initObserver();
});

document.addEventListener('DOMContentLoaded', function() {
  // Find the ProductJson script element dynamically
  const productJsonScript = document.querySelector('[id^="ProductJson-"]');
  if (!productJsonScript) {
    console.error('ProductJson script element not found');
    return;
  }
  
  var productJson = JSON.parse(productJsonScript.textContent);
  var variantSelectors = document.querySelectorAll('[data-single-option-selector]');
  var addToCartButton = document.querySelector('[data-add-to-cart]');
  var productSelect = document.querySelector('[data-product-select]');
  var frameValueDisplay = document.querySelector('.frames.frame_value');
  
  // Exit early if essential elements are missing or if Dawn's variant-selects is present
  if (!addToCartButton || !productSelect || variantSelectors.length === 0) {
    console.log('Product form elements not found, skipping variant handling');
    return;
  }
  
  // If Dawn's variant-selects is present, let it handle variant changes
  if (document.querySelector('variant-selects')) {
    console.log('Dawn variant-selects found, skipping custom variant handling');
    return;
  }



  var selectors = {
    productPrice: '[data-product-price]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    afterpayPrice: '[data-afterpay-price]',
    unitPriceWrapper: '[data-unit-price-wrapper]',
    unitPrice: '[data-unit-price]',
    unitPriceMeasurementReferenceUnit: '[data-unit-price-measurement-reference-unit]'
  };

  function updateAddToCartState(variant) {
    if (addToCartButton) {
      if (variant && variant.available) {
        addToCartButton.disabled = false;
        var addToCartText = addToCartButton.querySelector('[data-add-to-cart-text]');
        if (addToCartText) {
          addToCartText.textContent = "Add to bag";
        }
      } else {
        addToCartButton.disabled = true;
        var addToCartText = addToCartButton.querySelector('[data-add-to-cart-text]');
        if (addToCartText) {
          addToCartText.textContent = "Out of stock";
        }
      }
    }
    
    // Also update the product-form variant input disabled state
    var productVariantInput = document.querySelector('.product-variant-id');
    if (productVariantInput) {
      if (variant && variant.available) {
        productVariantInput.disabled = false;
      } else {
        productVariantInput.disabled = true;
      }
    }
  }

  function updateProductPrices(variant) {
    if (!variant) return;

    // General price elements above the variants
    const priceContainer = document.querySelector('[data-product-price]');
    
    // Update the main price display using dedicated spans; do not replace container HTML
    if (priceContainer) {
      const currentSpan = priceContainer.querySelector('[data-current-price]');
      const compareSpan = priceContainer.querySelector('[data-compare-price]');
      const percentSpan = priceContainer.querySelector('[data-percent-off]');

      const withCurrency = (cents) => (Shopify.currency_code_enabled && Shopify.money_with_currency_format)
        ? Shopify.formatMoney(cents, Shopify.money_with_currency_format)
        : Shopify.formatMoney(cents);

      // Determine pricing mode from data attribute
      const mode = priceContainer.getAttribute('data-pricing-mode') || 'standard';

      let showCompare = false;
      let percentOffText = '';
      let primaryCents = variant.price;
      let compareCents = 0;

      if (mode === 'custom') {
        // Custom discount mode driven by window.discountRate and Liquid-rendered compare price
        const dr = typeof window.discountRate === 'number' && window.discountRate > 0 && window.discountRate < 1
          ? window.discountRate
          : null;
        if (dr) {
          primaryCents = Math.round(variant.price * dr);
          compareCents = variant.price;
          showCompare = true;
          const pct = Math.round((1 - dr) * 100);
          percentOffText = pct > 0 ? `${pct}% OFF` : '';
        } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          // Fallback to standard behavior if discountRate isn't present
          primaryCents = variant.price;
          compareCents = variant.compare_at_price;
          showCompare = true;
          const pct = Math.round(((compareCents - primaryCents) / compareCents) * 100);
          percentOffText = pct > 0 ? `${pct}% OFF` : '';
        } else {
          primaryCents = variant.price;
          showCompare = false;
        }
      } else {
        // Standard: rely on compare_at_price > price (typically set by Sales & Discount app)
        primaryCents = variant.price;
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareCents = variant.compare_at_price;
          showCompare = true;
          const pct = Math.round(((compareCents - primaryCents) / compareCents) * 100);
          percentOffText = pct > 0 ? `${pct}% OFF` : '';
        }
      }

      // Apply to DOM spans if present
      if (currentSpan) currentSpan.textContent = withCurrency(primaryCents);
      if (compareSpan) {
        if (showCompare) {
          compareSpan.textContent = withCurrency(compareCents);
          compareSpan.classList.remove('hide');
        } else {
          compareSpan.textContent = '';
          compareSpan.classList.add('hide');
        }
      }
      if (percentSpan) {
        if (showCompare && percentOffText) {
          percentSpan.textContent = percentOffText;
          percentSpan.classList.remove('hide');
        } else {
          percentSpan.textContent = '';
          percentSpan.classList.add('hide');
        }
      }
    }

    // Aug 14, 2025: Removed price output inside Add to Cart button per request.
    // Leaving the wrapper (if present) empty to avoid layout/CSS shifts; no styling changes here.
    const buttonPriceWrapper = document.querySelector('.price_toggle[data-price-wrapper]');
    if (buttonPriceWrapper) {
      buttonPriceWrapper.innerHTML = '';
    }

    // Updating additional price elements (like afterpay, compare price, etc.)
    const afterpayPrice = document.querySelector(selectors.afterpayPrice);
    if (afterpayPrice) {
        const afterpayFormatted = Shopify.currency_code_enabled && Shopify.money_with_currency_format ? 
            Shopify.formatMoney(variant.price / 4, Shopify.money_with_currency_format) : 
            Shopify.formatMoney(variant.price / 4);
        afterpayPrice.innerHTML = afterpayFormatted;
    }

    const comparePrice = document.querySelector(selectors.comparePrice);
    const comparePriceText = document.querySelector(selectors.comparePriceText);
    if (comparePrice && comparePriceText) {
        if (variant.compare_at_price > variant.price) {
            const comparePriceFormatted = Shopify.currency_code_enabled && Shopify.money_with_currency_format ? 
                Shopify.formatMoney(variant.compare_at_price, Shopify.money_with_currency_format) : 
                Shopify.formatMoney(variant.compare_at_price);
            comparePrice.innerHTML = comparePriceFormatted;
            comparePrice.classList.remove("hide");
            comparePriceText.classList.remove("hide");
        } else {
            comparePrice.innerHTML = "";
            comparePrice.classList.add("hide");
            comparePriceText.classList.add("hide");
        }
    }

    // Update unit pricing if applicable
    updateUnitPricing(variant);
}


  function updateUnitPricing(variant) {
    const unitPriceContainer = document.querySelector(selectors.unitPriceWrapper);
    const unitPrice = document.querySelector(selectors.unitPrice);
    const unitPriceBaseUnit = document.querySelector(selectors.unitPriceMeasurementReferenceUnit);

    if (unitPriceContainer && unitPrice && unitPriceBaseUnit) {
      if (variant.unit_price) {
        const unitPriceFormatted = Shopify.currency_code_enabled && Shopify.money_with_currency_format ? 
            Shopify.formatMoney(variant.unit_price, Shopify.money_with_currency_format) : 
            Shopify.formatMoney(variant.unit_price);
        unitPrice.innerHTML = unitPriceFormatted;
        unitPriceBaseUnit.innerHTML = variant.unit_price_measurement.reference_unit;
        unitPriceContainer.classList.remove('hide');
      } else {
        unitPriceContainer.classList.add('hide');
      }
    }
  }

  function updateVariantId(variant) {
    if (variant && productSelect) {
      productSelect.value = variant.id;
    }
    
    // Also update the product-form variant input for cart drawer integration
    var productVariantInput = document.querySelector('.product-variant-id');
    if (variant && productVariantInput) {
      productVariantInput.value = variant.id;
      productVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function getSelectedOptions() {
    var selectedOptions = [];
    variantSelectors.forEach(function(selector) {
      if (selector.tagName === 'SELECT') {
        selectedOptions.push(selector.value);
      } else if (selector.tagName === 'INPUT' && selector.type === 'radio' && selector.checked) {
        selectedOptions.push(selector.value);
      }
    });
    return selectedOptions;
  }

  function getSelectedVariant() {
    var selectedOptions = getSelectedOptions();
    return productJson.variants.find(function(variant) {
      return variant.options.every(function(option, index) {
        return option === selectedOptions[index];
      });
    });
  }
  function handleOptionChange(event) {
    var selectedVariant = getSelectedVariant();
    if (selectedVariant) {
      updateAddToCartState(selectedVariant);
      updateProductPrices(selectedVariant);
      updateVariantId(selectedVariant);
    }
  
    // Check if event.target exists and has the 'name' property
    if (event.target && event.target.name === 'frame' && frameValueDisplay) {
      frameValueDisplay.textContent = event.target.value || '';
    }
  }
  

  // Add event listeners to all variant selectors
  variantSelectors.forEach(function(selector) {
    if (selector.tagName === 'SELECT') {
      selector.addEventListener('change', handleOptionChange);
    } else if (selector.tagName === 'INPUT' && selector.type === 'radio') {
      selector.addEventListener('change', handleOptionChange);
    }
  });

  // Initial update
  handleOptionChange({ target: document.querySelector('[data-single-option-selector]:checked') || document.querySelector('[data-single-option-selector]') });

  // Aug 14, 2025: Defensive cleanup – remove any leftover dash divider span and trailing hyphen
  // in case cached Liquid still rendered <span class="cart-divider">-</span>.
  document.querySelectorAll('.cart-divider').forEach(function(el){ el.remove(); });
  const atcText = document.querySelector('[data-add-to-cart-text]');
  if (atcText) {
    atcText.textContent = atcText.textContent.replace(/\s*-\s*$/,'');
  }

  // Add visual feedback on Add to Cart while request is in-flight (native drawer only)
  (function setupAddToCartLoadingState() {
    var atcButton = document.querySelector('[data-add-to-cart]');
    if (!atcButton) return;

    var labelEl = atcButton.querySelector('[data-add-to-cart-text]');
    var originalText = labelEl ? labelEl.textContent : '';
    var clearTimer;

    function setAddingState() {
      // If disabled (sold out), ignore
      if (atcButton.hasAttribute('disabled') || atcButton.getAttribute('aria-disabled') === 'true') return;
      atcButton.classList.add('adding-to-cart');
      if (labelEl) labelEl.textContent = 'Adding…';
      if (clearTimer) clearTimeout(clearTimer);
      // Failsafe clear in case no events fire
      clearTimer = setTimeout(clearAddingState, 10000);
    }

    function clearAddingState() {
      atcButton.classList.remove('adding-to-cart');
      if (labelEl) labelEl.textContent = originalText || 'Add to bag';
      if (clearTimer) clearTimeout(clearTimer);
      clearTimer = null;
    }

    // Trigger loading state on click
    atcButton.addEventListener('click', setAddingState);

    // Clear on theme pubsub cart updates if available
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { clearAddingState(); });
      }
    } catch (e) {}

    // Clear when native drawer opens
    try {
      var observer = new MutationObserver(function () {
        if (document.querySelector('cart-drawer.active')) { clearAddingState(); }
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
      window.addEventListener('pagehide', function () { observer.disconnect(); });
    } catch (e) {}
  })();

});

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

document.addEventListener('DOMContentLoaded', function() {
  console.log('Flickity carousel initialized');
  var flickityContainer = document.querySelector('.mobile-flickity'); // Select the Flickity container
  var flickitySlides = flickityContainer.querySelector('.mobile-flickity__slides'); // Select the slides
  var nextButton = flickityContainer.querySelector('.btn--next'); // Select the next button

  // Check if there are enough slides to enable wrapAround
  var noChildren = flickitySlides.children.length;
  var wrapAround = noChildren > 2;

  // Initialize Flickity
  var flickityInstance = new Flickity(flickitySlides, {
    freeScroll: true,
    watchCSS: true,
    wrapAround: wrapAround,
    cellAlign: 'left',
    contain: true,
    imagesLoaded: true,
    prevNextButtons: false, // We're using custom buttons
    pageDots: true,
    accessibility: false
  });

  // Set up a custom "next" button to advance the slides
  if (nextButton) {
    nextButton.addEventListener('click', function() {
      flickityInstance.next();
    });
  }

  // Handle iOS touch event bug fixes for dragging
  flickitySlides.addEventListener('dragStart.flickity', function() {
    document.ontouchmove = function(e) {
      e.preventDefault();
    };
  });

  flickitySlides.addEventListener('dragEnd.flickity', function() {
    document.ontouchmove = function(e) {
      return true;
    };
  });

  // If there's a selected element (like `.initial-selected`), start Flickity from that slide
  var initialSelected = flickitySlides.querySelector('.initial-selected');
  if (initialSelected) {
    var index = Array.from(flickitySlides.children).indexOf(initialSelected);
    flickityInstance.select(index);
  }

  // Handle Flickity state changes for accessibility (if needed)
  flickitySlides.addEventListener('change.flickity', function() {
    // If you need to manage focus or other accessibility-related changes, implement them here
  });
});
